import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'
import classes from './FormLabel.scss'

export const FormLabel = (props) => {
  let className = {
    [classes['label']]: classes['label'],
    [classes['label--error']]: props.touched && props.error && classes['label--error']
  }
  props.options.forEach((option) => {
    className[classes[`label--${option}`]] = classes[`label--${option}`]
  })
  className = cx(className)

  return (
    <label className={className}>
      {props.label && <div className={classes['title']}>
        {props.label}

        {props.button && <div className={classes['title-buttons']}>
          {props.button}
        </div>}
      </div>}
      {props.subLabel && <span className={classes['sub-label']}>{props.subLabel}</span>}

      <div className={classes['content']}>{props.children}</div>

      {props.note && <span className={classes['note']}>{props.note}</span>}
      {props.touched && props.error && <span className={classes['error']}>{props.error}</span>}
    </label>
  )
}

FormLabel.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  subLabel: PropTypes.string,
  note: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  touched: PropTypes.bool,
  error: PropTypes.string,
  options: PropTypes.array,
  button: PropTypes.node
}

FormLabel.defaultProps = {
  options: ['block'],
  touched: false
}

export default FormLabel



// WEBPACK FOOTER //
// ./src/components/Form/Label/FormLabel.js